// extracted by mini-css-extract-plugin
export default {"button":"EntraAuthButton_button__LAIwX"};